<template>
    <el-drawer
        :title="formData && formData.id ? '编辑语音' : '上传语音'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        :show-close="false"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
            >
                <el-form-item v-if="!formData.id" prop="fileUrl">
                    <el-upload action :http-request="uploadMusic" ref="uploadMp3" accept="audio/mpeg,audio/wav"
                        :show-file-list="false" :disabled="uploadMP3Loading" :on-change="onChange">
                        <el-button type="primary" icon="el-icon-upload" size="medium"
                            :loading="uploadMP3Loading">上传MP3</el-button>
                    </el-upload>
                </el-form-item>
				<el-form-item prop="name" label="语音名称:">
				    <el-input v-model="formData.name" placeholder="请输入歌曲名称" size="medium" max="20"></el-input>
				</el-form-item>                              
                <el-form-item label="购票成功页面播放演出:">                    
                    <el-input placeholder="填写演出ID，多个ID之间用逗号分隔" v-model="sActivityIds">
                        <el-button slot="append" icon="el-icon-search" @click="searchActivity()">添加演出</el-button>
                    </el-input>
                    <el-table class="MT10 sortable-table" :data="sActivityList" size="mini" border stripe v-loading="sActivityLoading" row-key="id">                        
                        <el-table-column prop="id" label="演出ID" width="90"></el-table-column>
                        <el-table-column prop="name" label="演出名称" show-overflow-tooltip></el-table-column>                        
                        <el-table-column label="操作" width="80">
                            <template slot-scope="scope">
								<el-button type="text" @click="delActivity(scope.row.id)" >解绑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
				<el-form-item prop="status" label="播放状态:">
				    <el-radio-group v-model="formData.status" size="medium">
				        <el-radio :label="1">开启</el-radio>
				        <el-radio :label="0">关闭</el-radio>
				    </el-radio-group>
				</el-form-item>  
                <el-form-item v-if="formData.id" label="文件:">
                    {{fileName}} <el-button type="text" size="mini" icon="el-icon-download" @click="download" :loading="downloadLoading">下载</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button v-if="!btnLoading" @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import {uploadAudio,downloadFile} from '@/assets/js/commonApi'
const defaultFormData = {
    status:1,
    name:"",
    fileUrl:"",   
    time:'',
    activityIds:''
}
export default {
    
    data(){
        return{
            drawerShow: false,
            btnLoading:false,
            formData:{...defaultFormData},
            rules:{
                name: [{ required: true, message: "请输入歌曲名称" },{ max: 20, message: "名称不能超过20个字符" }],
                fileUrl: [{ required: true, message: "请上传歌曲" }],                
            },            
            
            uploadLoading:false,
            fileName: '',
            downloadLoading: false,
			
			sActivityIds: "",
			sActivityLoading: false,
			sActivityList: [],
			uploadMP3Loading:false,
			id:''
        }
    },
    created(){
        
    },
    methods:{       
        close() {
            this.formData = {...defaultFormData};
            this.$refs['formData'].clearValidate();
            this.drawerShow = false;
			this.sActivityIds = ''
			this.sActivityList = [];
        },
        show(id) {            
            this.id = id;            
            this.drawerShow = true;
			if( this.id ){
				this.getData()
			}
        },
		// 获取详情
		getData() {		    
		    this.$request({
		        url: "/voice/detail",
		        method: "POST",
		        params: { id: this.id },
		    }).then((res) => {
		        //处理成功回调
		        const { state, msg, result } = res.data;
		        if (state && state == 1 && result) {
		           this.formData = {
		               name: result.name ? result.name: '',
		               status : result.status ? result.status: 1,
					   fileUrl: result.fileUrl ? result.fileUrl: '',
					   id:result.id ? result.id: '',
					   time:result.time ? result.time :'',
					   filePath: result.filePath ? result.filePath: '',
		           }
				   this.sActivityList = result.activityList
				   this.fileName = this.formData.name+'.'+(this.$utils.getFileType(this.formData.filePath) || 'mp3');
		        } else {
		            return this.$message.error(msg || "获取详情失败");
		        }
		    }).finally(() => {
		        
		    });
		},
		//搜索演出
		async searchActivity(callback) {
		    if (this.sActivityIds) {
		        this.sActivityLoading = true;
		
		        this.sActivityIds = this.sActivityIds.replace(/，/g, ',');
		
		        let _sActivityIds = this.sActivityIds.split(',');
		        _sActivityIds.map((v, i) => _sActivityIds[i] = parseInt(v));
		
		        const res = await this.$request({
		            url: '/activity/activityIdNameList',
		            method: 'post',
		            data: _sActivityIds
		        }).catch(() => {
		            return { data: { state: '0', msg: '请求错误' } };
		        }).finally(() => {
		            this.sActivityLoading = false;
		        });
		
		        const { state, msg, result } = res.data;		
		        if (state != 1) {
		            return this.$message.error(msg || '请求失败');
		
		        } else {
		            if (result && result.length > 0) {		
		                result.map(item => {
		                    if (!this.sActivityList.find(v => v.id == item.id)) {
		                        this.sActivityList.push(item)
		                    }
		                })		               
		                callback && callback();		
		            } else {
		                this.$message.error(msg || '没有找到相关演出');
		            }
		        }
		    }
		},
		//删除演出
		delActivity(id) {
		    this.sActivityList = this.sActivityList.filter(v => v.id != id);
		},
		onChange(file){
		    if(file){
		        let _name = file.name;
		        _name = _name.substring(0,_name.lastIndexOf('.'))
		        this.formData.name = _name;		        
		        this.$refs["formData"].clearValidate('fileUrl');
		        
		    }else{
		        this.formData.fileUrl = '';
		    }
		},
        async uploadMusic(req){
            const {file} = req;
            
            const isType = file.type === 'audio/mpeg' || file.type === 'audio/wav';
            if (!isType) {
                return this.$message.error('只能上传MP3或WAV格式的音频!');
            }
			console.log(file.size/1024)
			if( file.size/1024 > 500 ){
				return this.$message.error('音频大小不能超过500KB!');
			}
            this.uploadMP3Loading = true;
            const formData = new FormData();
            formData.append('file', file);
        
            // let filePath;
            const res = await uploadAudio(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
                this.formData.musicUri = '';
            }).finally(() => {
                this.uploadMP3Loading = false;
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                this.$nextTick(() => {
                    this.formData.fileUrl = result.url;
					this.formData.time = result.time
                })
            }else{
                this.$message.error(msg || '上传失败');
                this.formData.musicUri = '';
            }
        },
		
		//表单提交
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.submitAction()
                } else {
                    return false;
                }
            });
        },
        submitAction(){
            const _url = "/voice/save";
			let _activityIds = [];
			this.sActivityList.map(item => {
			    if(!item.ids || item.ids.length < 1){
			        _activityIds.push(item.id);
			    }
			})
			if( _activityIds == ''){
				return this.$message.error('绑定演出不能为空！');
			}
            this.btnLoading = true;
            this.$request({
                url: _url,
                data: {
					...this.formData,
					activityIds: _activityIds.toString(),
				},
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$emit('onUpdate');
                        this.close();
						this.btnLoading = false;
                    } else {
                        this.httpError = true;
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.httpError = true;
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });   
        },
        async download(){
            this.downloadLoading = true;
            await downloadFile(this.formData.filePath,this.fileName);
            this.downloadLoading = false;
        }
    }
}
</script>
